export default __webpack_public_path__ + "./images/ck.b541c304.png";